import { GetUserType } from '@orbit/api-types'
import api from '@lib/api'
import { useQuery } from '@tanstack/react-query'

interface GetMembersResponse {
	members: GetUserType[]
}

export const useTripMembers = (tripId: string | undefined) => {
	return useQuery<GetMembersResponse>({
		queryKey: ['tripMembers', tripId],
		queryFn: async () => {
			if (!tripId) {
				throw new Error('Trip ID is required')
			}
			const response = await api.get<GetMembersResponse>(`/trips/${tripId}/members`)
			return response.data
		},
		enabled: !!tripId, // Only run query if tripId is provided
		retry: 1,
	})
}

